import {SERVICES} from './services';

const PREFIX = `${SERVICES.STATIC_URL}/s`;

export const IMAGES = {
  GOOGLE_PLAY: '/home/download/google-play.png',
  APP_STORE: '/home/download/app-store.png',
  APP_DOWNLOAD_QR_CODE: '/home/download/qrcode.png',
  ANNOUNCEMENT: '/web/media/announcement.svg',
  ANNOUNCEMENT_BLUE: '/web/media/announcement_blue.svg',
  DOWNLOAD: '/web/media/download.svg',
  DOWNLOAD_BLUE: '/web/media/download_blue.svg',
  INVITE_BG: '/web/account/invite-friends/invite-bg.png',
  PREMIUM_CENTER_ICON: '/web/account/premium-center.svg',
  PREMIUM_CENTER_ICON_DARK: '/web/account/premium-center-dark.svg',
  PREMIUM_CENTER_ICON_HOVER: '/web/account/premium-center-hover.svg',
  GIFT_BOX: '/web/account/invite-friends/gift-box.svg',
  ZERO_FEE: '/web/account/zerofees.svg',
  GUIDANCE_IMG_1: '/trade/guidance/1.png',
  GUIDANCE_IMG_2: '/trade/guidance/1.png',
  GUIDANCE_IMG_3: '/trade/guidance/1.png',
  GIVE_AWAY: '/web/assets/give-away-v2.svg',
  FACEBOOK_IMG: '/web/media/facebook.svg',
  TWITTER_IMG: 'https://img.phemex.com/v1/c80f707e-e491-410c-b9ed-e28fdf5e3d6c/twitter.svg',
  TELEGRAM_IMG: '/web/media/telegram.svg',
  YOUTUBE_IMG: '/web/media/youtube.svg',
  MICROBLOG_IMG: '/web/media/microblog.svg',
  NOTIFY: '/trade/spot/notice-img.png',
  MICRO_BLOG: '/web/media/microblog.svg',
  INVITE_FRIENDS_PEOPLE: '/home/account/invite-friends/people.png',
  INVITE_FRIENDS_ACQUIRE: '/home/account/invite-friends/acquire.svg',
  INVITE_FRIENDS_EARN: '/home/account/invite-friends/earn-blue.svg',
  CRYPTO_TRADING_HOT: '/home/war/hot-v3.svg',
  LOGO_DARK: '/home/logo/logo-light-v2.svg',
  LOGO_LIGHT: '/home/logo/logo-dark-v2.svg',
  CONTRACT_LOGO_DARK: '/home/logo/contract-logo-light.svg',
  CONTRACT_LOGO_LIGHT: '/home/logo/contract-logo-dark.svg',
  LOGO_TEST_NET_LIGHT: '/home/logo/testnet-logo-dark.svg',
  LOGO_TEST_NET_DARK: '/home/logo/testnet-logo-light.svg',
  TAG_NEWS: '/home/earn/earn-new.svg',
  EARN_ORANGE: '/home/earn/earn-orange.svg',
  EARN_NEW_2: '/home/earn/earn-new-2.svg',
  NO_LOGIN_MASK: '/home/3.0/mask.png',
  GET_PREMIUM: '/trade/spot-guidance/sorry.png',
  PREMIUM: '/home/receive/premium.png',
  STANDARD_USER: '/home/account/account-security/standard_user.png',
  PREMIUM_TRIAL: '/home/account/account-security/premium_trial.png',
  SORRY: '/trade/spot-guidance/sorry.png',
  WARING: '/home/war/waring.png',
  PAY_ERROR: '/web/account/payerror_v1.svg',
  PREMIUM_NOTIFICATION_WARING: '/web/account/notification_waring.svg',
  PREMIUM_NOTIFICATION: '/web/account/notification.svg',
  SHARE_INVITE_FRIENDS: '/home/account/invite-friends/share_v1.png',
  PREMIUM_TRAIL: '/home/receive/premium-trail.png',
  NEW: '/web/account/new.svg',
  EARN: '/web/account/earn.svg',
  LAUNCHPOOL: '/web/account/lanuchpool_icon_v1.svg',
  EARN_CRYPTO: '/web/account/earn-crypto-v2.svg',
  HOT: '/home/2.0/hot.png',
  COPY_TRADE_LIGHT: '/trade/copy-trading/ct-light.svg',
  COPY_TRADE_DARK: '/trade/copy-trading/ct-dark.svg',
  CONTRACT_MENU: '/trade/copy-trading/contract-menu.svg',
  COPY_TRADING_MENU: '/trade/copy-trading/copy-trading-menu.png',
  LEADERBOARD_MENU: '/trade/copy-trading/leaderboard-menu.svg',
  NO_DATA: '/home/buy-crypto/no-data.png',
  GRID_LIGHT: '/home/menu/gird-dark.svg',
  GRID_DARK: '/home/menu/grid-light.svg',
};

Object.keys(IMAGES).forEach((key) => !IMAGES[key].startsWith('https://') && (IMAGES[key] = [PREFIX, IMAGES[key]].join('')));

const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;

export const IMAGES_HASH = {
  EARN_HOME: '716c8088a9894cefd1a75cb9276e688c633025185ffbac7ca876ded08a94535f.png',
  SPOT_TRADING: 'f821c3543d0ee1dd31d53668d0654eb08a34afa881cc1aa3fe2fb4a64e23db8e.png',
  MARGIN_TRADE_ICON: '0f13a181a5f87d62d620490c276f9a33638c5fb0df6aeece828028296c2c769c.png',
  CONVERT: '881843ab755d4ec18b581e2ba53c1535f97f70aef1a8e8997f829c6e2de9c52f.png',
  LAUNCHPAD: '9515716d0bf8084e174c2779c201d0d2cc6931bea0ca78b07da96e645e23092c.png',
  OTC: 'ff763f30963144efea49f64bb97a6184ce0b26da0ae5ea6aff2101b53dca7978.png',
  BONUS: '476075d97dbd718f1361a9a0d9345ad320e7b9766323b6ff57841d8fec1b3526.png',
  BUY_CRYPTO_DEPOSIT: '168c24f6c27429bd8e57b11c6aa2dd891669964c866e086f326c71cac71dd761.png',
  CREDIT_CARD: 'dc0c95c291a35ca47f767e5d3e3322b4caa11d035fae90aeef2879841e1b116f.png',
  PREMIUM: '998dc3a8a2a392eda453f6aca4e2bebc8c6b37a58b7f7773c7251bd7f85a963d.png',
  P2P_MARKER_PLACE_ICON: '9c3908b994a609a5e0d8437d0e357ad2a3331a47d6b6b1aeabffa48542665d02.png',
  NOTE_KYC: '67c69539b15fc689e76dc336c705c3400a86a232b9dda81fd59fcce2549f094e.png',
  USER_KYC: '53535b364903443c5cff56551a81d249a2f5c46888dcda945da09fb5937dcd41.png',
  CONTRACT_TRADE: '06c8ac40535a7491ae494b15bb42284c1fdca4804f73653abb70e8df330c2f72.png',
  COPY_TRADE: 'f2d92837be42253e3cb597d414530dac91d7b669961354aefedf014a29f49a37.png',
  PREDICT_ICON: 'acfbcd1ad0e7e87c82d8e8527ebbbc1a36d9544e4094151aca44d00c90c8246b.png',
  DANGER_ICON: '714130c1c44e093df75a169ffadd19251701cb9e80b80a6e240a546f1790fa4e.png',
  RECOMMEND_GIFT: '8f48aea164b034999266cc59b84c9e04ea536ac7baa225663936821e0b6bc8a0.png',
  COINM_MENU: 'bb1e2564aabb7ae0810f4e2a02abfba2e8f0d6ce88a1400ebec5c927eca6ccca.png',
  COINS_MENU: '394994490bcba826df2f42d07982de7b639ed6ee7f40eacf8d2ec75cbc0c6e76.png',
  VIP_MENU: '03ce95826ed67df8c47fcc17f9d162a89181ac0fb063c550c586320780dbfa55.png',
  TRANSFER: 'ffbe3afaf92a89435a6c465da4ada5dc95ce1ee2384b76497013e44273a37865.png',
  BANNER: '30f366b863d7b22e753ec004f8599e1a1b55749ba5f92bdd1de0e9f47e25c946.png',
  M_BANNER: 'cd29b4b1b63dcfabc859ba20e2c4d70d01856a18a040d292b2708b76ed549998.png',
  CONVERT_DISABLED: '22dc33c0500f16f3e1f018056b3a8f42a709207dfc13286857d1d926d65ea294.png',
  CONVERT_SUCCESS: '6e3644c4a966963a5ea3adb1f2a0b56fd4f382c94483ec745d87e48254e3ffb8.png',
  CONVERT_FAIL: '3f2dbcdcf0fb08f72db81eafcdee223a35decf8c19ab15ed7abcec028c3346a6.png',
  CREDIT_DEBIT_CARDS: '925a281e64e62a543f0b4dfbfbd3aee4d1b2b6b54119cbed9223cc689c4bc401.png',
  TWITTER: 'ebe1e569754ba8f435cf5a544055e97de553af55f5d50a80e8d615ef7bcc0672.png',
  FACEBOOK: '9cee169afafc0a56bcbe71d559391ebe9b909950ee7fe50369ff1d1379ddd945.png',
  TELEGRAM: '856f72e850e5b99ded18adbf3bae80f657f051f4640c292eaf6811da45b1d083.png',
  LINKEDIN: 'db9366f85057d6c59a3d88505756100ec16605ee16abdeff7407d95c583a3210.png',
  REDDIT: '95ff654d0d6addbc89a07d38e3b9d2e514ee62a9e1235c285d007dc871125c67.png',
  JP_LOGO_PULSE_LIGHT: 'https://img.phemex.com/v1/1cc9be82-934c-459d-8387-fd4d9be588f6/logo-pulse-social.png',
  JP_LOGO_PULSE_DARK: 'https://img.phemex.com/v1/1cc9be82-934c-459d-8387-fd4d9be588f6/logo-pulse-social.png',
  Level1: '274d8392c0fcb1ea83b1fc5a388118d4e8a3a3f774342b1b71feee63bb73a7d8.png',
  Level2: '68869cd2f6a27a22ba5076b3bef0130ccf1872641c5c0f0833dab188105202b9.png',
  Level3: '27231853d8ecb59aee8b72b4f05ab2a76f704298c8ff3ef0d1b8abc6a8c84c86.png',
  OG: 'ba6e212389adabcf0c72252f9c61fb398fe0df1b5030efb0f022a8a665162bde.jpg',
};

Object.keys(IMAGES_HASH).forEach((key) => (IMAGES_HASH[key] = IMAGES_HASH[key].startsWith('https://') ? IMAGES_HASH[key] : [PREFIX_RECEIVE, IMAGES_HASH[key]].join('')));
const PREFIX_RECEIVE_V2 = `${SERVICES.IMG_URL}/v1/`;

export const IMAGES_V2 = {
  BOOK_DEFAULT: '284b7e62/default.png',
  BOOK_BUY: 'e6729700/buy.png',
  BOOK_SELL: '09122f04/sell.png',
  BADGE_HOT: 'c5c072e4/hot.png',
  BADGE_NEW: '7fe796c9/new-v1.png',
  BADGE_ZERO_FEE: 'f61e4edd/zero-fee.png',
  NEW: 'd4f84019/new.png',
  SHARE_BG: 'dc7ecf3d/trading-bots.png',
  BOTS_ICON: '9b968b03/bot.png',
  OG: '01eacd71/bots-og.png',
  COPY: '0541141f/copy.png',
  SAVE: 'f2e759d5/save.png',
  LOGO_LIGHT: 'd4dd5c7b/logo-transparent.png',
  NO_DATA: 'c4765a2f/nodata-2x.png',
  COPY_PEOPLE_DARK: 'ea11db48/join.png',
  COPY_PEOPLE_LIGHT: '67765928/join-light.png',
  SHARE: '27121c82/share.png',
  POSITION_SHARE_BG: '1bffa139/share-bg.png',
  POSITION_SHARE_BG2: '156af948/share-bg2.png',
  MOCK_TRADING: '7999a568/mock-trading.png',
  INCREASING_DARK: 'e57aebc9-e17b-4620-8199-f3865cf371ab/increasing.svg',
  INCREASING_LIGHT: 'aaf5699b-fa7a-4875-b17a-b72b5026d0a5/increasing-light.svg',
  DEGRESSION_DARK: '786b4f5e-9e34-4553-8725-f3a7bef85b80/degression.svg',
  DEGRESSION_LIGHT: 'e6e8b5d9-c472-49e4-86bd-1d9539daad21/degression-light.svg',
  SCALED_ORDER: 'dc714e59-2574-4988-a25e-eb1a045fb15b/scaled-order.png',
  FIRE: '664623f1-8884-4e08-81ff-c71e0d3fd96e/fire.svg',
  STAR: 'e8a54035-06ca-4602-b73d-60effcb72bb4/new-star.svg',
  CIRCLE_RIGHT: '09e2ce6c-4f98-4d38-a2bb-45078f524c0e/circle-right.svg',
  CIRCLE_RIGHT_CHECKED: 'd0943681-0dc3-4a8a-9d8d-1f8db82361b4/circle-right-checked.svg',
  ROCKET: '2522f35f-aa39-431c-a998-d87ff0ebbb8f/rocket.png',
  ROCKET_ICON: '4832067c-11a4-41ad-a255-cd93fa42cd5d/rocket-icon.png',
  BG_LOSS: 'ee6c7951-4bfd-41ca-9f85-79ed9eb68266/bg-loss3.png',
  BG_PROFIT: '884b4d2c-e8a9-494a-9055-ddf27ea81e20/bg-profit3.png',
  SAD_FROG: '31d3fe9a-971a-4ad8-850e-f3bdab6c39e7/sad-frog.png',
  HAPPY_FROG: '93859460-b84e-4d24-bb30-790afa3ad195/happy-frog.png',
  LIST_EMPTY: 'f8f6066b-1ccc-41c8-b1eb-22e8b5170855/cast-empty.png',
};

Object.keys(IMAGES_V2).forEach((key) => (IMAGES_V2[key] = [PREFIX_RECEIVE_V2, IMAGES_V2[key]].join('')));

export const SNS_IMAGES = {
  FACEBOOK_IMG: 'web/media/facebook.svg',
  TWITTER_IMG: 'https://img.phemex.com/v1/c80f707e-e491-410c-b9ed-e28fdf5e3d6c/twitter.svg',
  TELEGRAM_IMG: 'web/media/telegram.svg',
  MICROBLOG_IMG: 'web/media/microblog.svg',
  LINKEDIN_IMG: 'web/media/linkedin.svg',
  REDDIT_IMG: 'web/media/reddit.svg',
  VK_IMG: 'web/media/vk.svg',
  WHATSAPP_IMG: 'web/media/whatsapp.svg',
  SNAPCHAT_IMG: 'web/media/snapchat.svg',
};
const SNS_PREFIX = `${SERVICES.STATIC_URL}/s/`;
Object.keys(SNS_IMAGES).forEach((key) => !SNS_IMAGES[key].startsWith('https://') && (SNS_IMAGES[key] = [SNS_PREFIX, SNS_IMAGES[key]].join('')));

const PREFIX_RECEIVE_V3 = `${SERVICES.IMG_URL}/v1/`;

export const IMAGES_V3 = {
  COPY: 'a3a764cf-3ffa-4b49-a458-980bb52eb5ff/copy.svg',
  COPY_DARK: '61771e62-f6c6-4ea6-b62e-e2b5b8162e7b/copy.svg',
  SWITCH_ACCOUNT: 'b8877eeb-1600-4391-b9ea-0c8f277fce6e/active.svg',
  SWITCH_ACCOUNT_DARK: '1ca12e9a-5e54-4a10-8c8c-24633218fd03/switch-account.svg',
  OVERVIEW: '59a80562-a884-4351-9ab7-b01f5ad2e685/overview.svg',
  OVERVIEW_DARK: '000bb153-3863-43bb-847c-b2bc0443abcc/overview.svg',
  VERIFICATION: 'cce069df-e8fb-4322-9e08-4c8c4f324e4f/card.svg',
  VERIFICATION_DARK: 'ebd4173b-b955-45cd-a6ab-20abe3dc98a7/verification.svg',
  SECURITY: 'd44c7383-3108-4b37-9e8a-5fe58c680534/shield.png',
  SECURITY_DARK: '6f3a9c26-bdbe-462d-abfe-f3b85e195d00/security.svg',
  SUB_ACCOUNT: '53ee179f-2b17-457d-bbb3-4d684fd41bd6/sub-account.svg',
  SUB_ACCOUNT_DARK: 'ee5dc1b2-76d6-4ec5-80ed-827aa6f5dc1f/sub-account.svg',
  API: '1ef44646-50c2-4bac-90b8-09898ace0f83/api.svg',
  API_DARK: 'd14c9a45-2a92-4db5-b458-fa1fb5fa49fe/api.svg',
  TAX_REPORTING: 'be55ef8b-fa5c-4add-8fed-5c8563f54931/tax-reporting.svg',
  TAX_REPORTING_DARK: 'bafef2ac-6f90-4fc9-a94d-99f067edb2c1/tax-reporting.svg',
  INVITE_FRIENDS: 'c8ca7458-d655-4b5b-bd56-81985f6d75a8/active.svg',
  INVITE_FRIENDS_DARK: '0e64e27e-cd24-49a3-94d1-2bbac163a4db/invite-friends.svg',
  SETTING: '1b4d871e-720e-4877-936e-c07bdecde6f4/setting.svg',
  SETTING_DARK: '688f6349-1806-430b-ae63-2292080eae69/setting.svg',
  LOG_OUT: 'be7fecf0-1efe-47a0-878a-335b0f9c6fe5/active.svg',
  LOG_OUT_DARK: 'cfd43d03-6d5b-4b27-90ee-cc3d545e3da3/log-out.svg',
  AI_BACKTESTING: '4a6bdab1-8bd7-4a90-a996-582a931b1d3c/ai-backtesting.png',
};

Object.keys(IMAGES_V3).forEach((key) => (IMAGES_V3[key] = [PREFIX_RECEIVE_V3, IMAGES_V3[key]].join('')));
